'use client'
import { useEffect } from 'react';

export default function Error({ error }: {
  error: Error & { digest?: string }
  reset: () => void
}) {

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error)
  }, [error])

  return (
    <div className="px-4 min-h-screen flex justify-content-center align-items-center">
      <div className="z-1 text-center">
        <div className="text-900 font-bold text-5xl mb-4">Ops. Algo deu errado!</div>
        <button 
          className="p-button p-component font-medium p-button-raised p-button-default">
          Tentar novamente
        </button>
      </div>
    </div>
  )
}